<div fxLayout="column" fxFill>
  <div fxLayout="row" fxLayout.xs="row" fxFlex="8%">
    <div class="toolbar" fxFill>
      <span class="left">WebClock</span>
      <div ngbDropdown class="d-inline-block padding-right">
        <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle></button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem (click)="openTimeLogs()">View Timelogs</button>
          <button *ngIf="hide_voidreq == 0" ngbDropdownItem (click)="openVoidRequest()">Request Void Time Log </button>
          <button *ngIf="show_xptclockentries == 0" ngbDropdownItem (click)="openExportTimeLogs()">Export Clock Entries</button>
        </div>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayout.md="row" fxLayout.sm="column" fxLayout.xs="column" fxFlex="90%" fxFlex.xs="auto"
    fxFlex.s="auto" fxLayoutGap=".75%" class='padding'>
    <div fxFlex="50%" fxFlex.s="auto" fxFlex.xs="auto">
      <div fxFill class="grid">
        <div class=" margin-top row green">
          <input type="text" class="text-input center" [(ngModel)]="id" style="color: white;">
        </div>
        <p class="center enterEmployee">Enter Employee No</p>
        <div class="row">
          <div class="col">
            <button class="keypad button-md" (click)="input('1')">1</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="input('2')">2</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="input('3')">3</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="keypad button-md" (click)="input('4')">4</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="input('5')">5</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="input('6')">6</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="keypad button-md" (click)="input('7')">7</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="input('8')">8</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="input('9')">9</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="keypad button-md" (click)="clear()">Clear</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="input('0')">0</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="del()">Del</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="keypad button-md" (click)="submit('I')">TIMEIN</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="submit('O')">TIMEOUT</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="keypad button-md" (click)="submit('BI')">BREAK-IN</button>
          </div>
          <div class="col">
            <button class="keypad button-md" (click)="submit('BO')">BREAK-OUT</button>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxFlex="50%" fxLayoutGap="1%" fxFlex.s="auto" fxFlex.xs="auto">
      <div class="container" fxLayout.sm="column" fxLayout.xs="column" fxLayout="column" fxFlex="50%" fxFlex.sm="20%"
        fxFlex.xs="20%">
        <div class="logo">
          <img class="fill" src="assets/lst_logo.png">
        </div>
        <div class="clock">
          <span class="h1">{{ currentTime }}</span>
          <span>{{ today }}</span>
        </div>
        <div class="notes">
          <span class="h1">Always check your logs below after time in/out.</span>
        </div>
      </div>
      <div class="container" fxLayout="row" fxFlex="50%" fxFlex.s="auto" fxFlex.xs="auto">
        <div fxFill class="grid timeins justifycenter">
          <div class="row rowborder rowheader">
            <div class="col centerMedium flexcol">
              Employee
            </div>
            <div class="col25 centerMedium flexcol">
              Time
            </div>
            <div class="col25 centerMedium flexcol">
              In / Out
            </div>
          </div>
          <div class="row rowborder timeinrow" *ngFor="let timein of timeins">
            <div class="col">
              {{timein.fullname}}
            </div>
            <div class="col25 centerMedium flexcol">
              {{timein.timereg}} {{timein.ampm}}
            </div>
            <div class="col25 centerMedium flexcol">
              {{timein.in_out}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>